import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
                <span className="text-primary-500">土豪</span>
                <span className="text-background-50">漫画</span>
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              {siteInfo.description.slice(0, 60)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-50 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-50 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center text-background-50 hover:bg-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap flex items-center gap-2"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门推荐</h4>
            <ul className="space-y-2.5">
              <li><Link to="/comic/1" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">伪装学渣</Link></li>
              <li><Link to="/comic/4" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">一人之下</Link></li>
              <li><Link to="/comic/8" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">魔道祖师</Link></li>
              <li><Link to="/comic/5" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">天官赐福</Link></li>
              <li><Link to="/comic/2" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">斗破苍穹</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><Link to="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站漫画仅供学习交流，请勿用于商业用途
          </p>
          <p className="text-xs text-foreground-600">
            友情链接：
            <a href="#" className="hover:text-primary-400 transition-colors ml-1" rel="nofollow">漫画网</a>
            <span className="mx-1">·</span>
            <a href="#" className="hover:text-primary-400 transition-colors" rel="nofollow">免费漫画</a>
            <span className="mx-1">·</span>
            <a href="#" className="hover:text-primary-400 transition-colors" rel="nofollow">在线漫画</a>
          </p>
        </div>
      </div>
    </footer>
  );
}